export const seeAllRoles = ["Root", "Marketing", "AssortmentManager"];

export const permissions = {
  root: ["Root", "ITAdmin", "ITSupport"],
  products: [
    "Root",
    "StoreManager",
    "ExternalStoreManager",
    "FranchiseManager",
    "Marketing",
    "AssortmentManager",
    "DistributorManager"
  ],
  scanProduct: [
    "Root",
    "StoreManager",
    "ExternalStoreManager",
    "FranchiseManager",
    "AssortmentManager"
  ],
  stores: [
    "Root",
    "StoreManager",
    "ExternalStoreManager",
    "FranchiseManager",
    "AssortmentManager"
  ],
  doors: [
    "Root",
    "StoreManager",
    "ExternalStoreManager",
    "FranchiseManager",
    "AssortmentManager",
    "Distributor"
  ],
  reports: ["Root", "Economy", "StoreManager", "AssortmentManager"],
  campaigns: ["Root", "CampaignManager", "Marketing"],
  productCampaigns: ["Root", "Support", "ITAdmin", "ITSupport"],
  marketing: ["Root", "Marketing"],
  discounts: ["Root", "Marketing", "AssortmentManager", "Support"],
  users: [
    "Root",
    "StoreManager",
    "FranchiseManager",
    "Marketing",
    "AssortmentManager",
    "Support"
  ],

  statistics: [
    "Root",
    "StoreManager",
    "FranchiseManager",
    "Marketing",
    "AssortmentManager"
  ],
  stocktakingManager: ["Root", "AssortmentManager"],
  public: ["DistributorManager"],
  overview: [
    "Root",
    "Economy",
    "Support",
    "CampaignManager",
    "StoreManager",
    "ExternalStoreManager",
    "FranchiseManager",
    "Marketing",
    "AssortmentManager"
  ]
};

export const whiteLabelCampaignRoles = [
  ...permissions.stores,
  ...permissions.campaigns,
  ...permissions.productCampaigns
];

export const UserEventType = {
  PAYMENT: "Payment",
  OPEN_DOOR: "OpenDoor",
  SCANNER_START_SCANNING: "StartScanning",
  SCANNER_ON_SCAN_FOUND: "ProductScanToCart",
  CART_INCREASE: "ProductManuallyAddToCart",
  CART_DECREASE: "ProductRemovedFromCart",
  CART_EMPTY: "CartEmpty"
};
